import styled from '@emotion/styled';
import type { LanguageSelectorColor } from './types';

export const Wrapper = styled.div<{ color: LanguageSelectorColor }>`
  color: ${(props) => props.theme.color[props.color].default};
  display: flex;
  align-items: center;
`;

export const Seperator = styled.span`
  padding: 0 5px;
`;

export const LanguageButton = styled.div<{ selected: boolean }>`
  cursor: pointer;
  padding: 2px 10px;
  font-weight: 500;
  color: inherit;
  font-weight: ${(props) => (props.selected ? 800 : 'unset')};
`;
